export const BASE_PATH = {
  UNITS: '/units',
  COMMUNITIES: '/communities',
  DESTINATION: '/destination',
};
export const APP_ROUTES = {
  HOME: '/',
  UNITS: `${BASE_PATH.UNITS}`,
  COMMUNITIES: `${BASE_PATH.COMMUNITIES}`,
  DESTINATIONS: `${BASE_PATH.DESTINATION}`,
  COMMUNITY_DETAILS: (id: string) => `${BASE_PATH.COMMUNITIES}/${id}`,
  DESTINATION_DETAILS: (id: string) => `${BASE_PATH.DESTINATION}/${id}`,
  UNIT_DETAILS: (id: string) => `${BASE_PATH.UNITS}/${id}`,
  RESALE: () => `/resale`,
  RETAIL: () => `/retail`,
  AFTER_CARE: () => `/aldar-aftercare`,
  PREMIUM_PARKING: () => `/premium-parking`,
};
const ALLOWED_LANGS = ['en', 'ar'];
export class Route {
  public static withLang(route: string, lang?: string) {
    if (lang && ALLOWED_LANGS.includes(lang)) return `/${lang}${route}`;
    else {
      const currentLang = window?.location?.pathname?.split('/')?.[1];
      if (currentLang && ALLOWED_LANGS.includes(currentLang))
        return `/${currentLang}${route}`;
      return `/en${route}`;
    }
  }

  public static withQueryStr(baseRoute: string, queryString?: string) {
    if (!queryString) return baseRoute;
    return `${baseRoute}?${queryString}`;
  }
  /**  Damascus Main Routes **/
  public static HOME = () => {
    return '/';
  };
  public static UNITS = () => {
    return BASE_PATH.UNITS;
  };
  public static UNIT_DETAILS = (unitId: string) => {
    return `${BASE_PATH.UNITS}/${unitId}`;
  };

  public static COMMUNITIES = () => {
    return BASE_PATH.COMMUNITIES;
  };
  public static COMMUNITY_DETAILS = (communitId: string) => {
    return `${BASE_PATH.COMMUNITIES}/${communitId}`;
  };

  public static DESTINATION_DETAILS = (destinationId: string) => {
    return `${BASE_PATH.DESTINATION}/${destinationId}`;
  };

  public static EXPERIENCE = () => {
    return process.env.NEXT_PUBLIC_HOSPITALITY_APP_URL ?? '';
  };

  public static PRIVACY_POLICY = () => {
    return '/privacy-policy';
  };

  public static RECENT_LAUNCHES = () => {
    return '/recent-launches';
  };

  /** Aldar Plus Routes */
  public static ALDAR_AFTERCARE = () => {
    return '/aldar-aftercare';
  };

  public static LOGISTIC_CENTERS = () => {
    return '/logistics-centres';
  };

  public static PREMIUM_PARKING = () => {
    return '/premium-parking';
  };

  public static RESALE = () => {
    return '/resale';
  };

  public static TASAREEH = () => {
    return '/tasareeh';
  };

  public static TASAREEH_CONTACT = () => {
    return '/tasareeh/contact';
  };

  public static TASAREEH_DOWNLOADS = () => {
    return '/tasareeh/downloads';
  };

  public static TASAREEH_FAQS = () => {
    return '/tasareeh/faqs';
  };

  public static TASAREEH_SERVICES = () => {
    return '/tasareeh/services';
  };

  public static NPS = () => {
    return `/nps`;
  };

  public static RETAIL = () => {
    return '/retail';
  };

  /** Legacy Pages  **/
  public static LEGACY_HOME = () => {
    return '/legacy';
  };

  public static LEGACY_UNITS = () => {
    return '/legacy/units';
  };
  public static LEGACY_UNIT_DETAILS = (unitId: string) => {
    return `/legacy/units/${unitId}`;
  };

  public static LEGACY_COMMUNITIES = () => {
    return '/legacy/communities';
  };
  public static LEGACY_COMMUNITY_DETAILS = (communitId: string) => {
    return `/legacy/communities/${communitId}`;
  };

  public static LEGACY_DESTINATIONS = () => {
    return '/legacy/destinations';
  };

  public static LEGACY_DESTINATION_DETAILS = (destinationId: string) => {
    return `/legacy/destinations/${destinationId}`;
  };

  public static ALDAR_EDUCATION = () => {
    return 'https://aldar.com/education';
  };

  public static ALDAR_LIVING = () => {
    return 'https://www.aldar.com/live/login';
  };

  public static TASAREEH_FEE_CALCULATOR = () => {
    return (
      process.env.NEXT_PUBLIC_TASAREEH_FEE_CALCULATOR ||
      'https://tasareeh.ae/dev-calculator'
    );
  };
  /** Marketing Pages **/
  // since we hardly cross reference Marketing pages, we are not referincing them here.
}
